import React, {useEffect} from 'react';
import classNames from "classnames";
import {useAiReportsContext} from '../context/AiReportsContext';
import {Button} from "react-bootstrap";
import {useIntl} from "react-intl";
import {Formik} from 'formik';
import PopupSelectSaved from "./PopupSelectSaved";
import {useDispatch} from "react-redux";
import {aiReportsSlice} from "../_redux/aiReportsSlice";
import {DataItemTextarea} from "../../_common/components/DataItemTextarea";
import ButtonExportToExcel from "../../_common/components/ButtonExportToExcel";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import {RequestCancellationManager} from "../../_common/utils/RequestCancellationManager";
import * as actions from "../_redux/aiReportsActions";
import styles from './styles.module.scss';

type QueryParams = Record<string, any>

type FilterValues = {
  query: string
  reportId: string
}

const prepareFilter = (queryParams: QueryParams, values: FilterValues): QueryParams => {
  const {query, reportId} = values

  const newQueryParams = {...queryParams}
  delete newQueryParams.reportId
  const filter: QueryParams = {}

  if (Boolean(query)) {
    filter.query = query
  } else {
    delete newQueryParams.query
  }
  if (Boolean(reportId)) {
    filter.reportId = reportId
  } else {
    delete newQueryParams.reportId
  }

  return {...newQueryParams, ...filter}
}

export function AiReportsFilter() {
  const dispatch = useDispatch();
  const {actions: aiReportsActions} = aiReportsSlice;
  const {formatMessage} = useIntl();
  const context = useAiReportsContext();

  const applyFilter = (values: FilterValues, queryChanged = false): void => {
    RequestCancellationManager.stopRequests(actions.aiReportsPrefix);

    const filterValues = queryChanged
      ? { ...values, reportId: '' }
      : values;

    const newQueryParams = prepareFilter(
      context.queryParams,
      filterValues
    );

    context.setQueryParams(newQueryParams);
  };

  useEffect(() => {
    return () => {
      dispatch(aiReportsActions?.resetState());
    };
  }, [dispatch]);

  return (
    <Formik
      initialValues={{query: '', reportId: ''}}
      onSubmit={() => {
      }}
      enableReinitialize={true}
    >
      {({values, ...formikProps}) => (
        <div className={'d-flex justify-content-center align-items-center mt-n10 mb-4 w-75 mx-auto position-relative'}>
          <div className={'d-flex align-items-center justify-content-between mr-2'}>
            <ButtonExportToExcel
              loading={context.exporting}
              exportFunc={() => context.handleExport()}
              disabled={!Boolean(context.entities) || context.loading || context.exporting}
            />
            <PopupSelectSaved
              setFieldValue={formikProps.setFieldValue}
              applyFilter={(values) => applyFilter(values)}
            />
            <Button
              className={'btn btn-sm custom-send-button p-1 w-40px h-40px mx-2'}
              onClick={async () => await context.saveQuery()}
              disabled={
              !context.reportId || context.isSaving || !context.entities ||
                context?.entities?.length === 0 || !values.query
            }
            >
              <img
                src={toAbsoluteUrl('/media/svg/Star_white.svg')}
                alt="i" width={26}
              />
            </Button>
          </div>
          <DataItemTextarea
            fieldId="query"
            value={values.query}
            customTextareaStyle="p-4 resize-none"
            placeholder={formatMessage({
              id: 'ai-reports-query',
              defaultMessage: 'Type your question here'
            })}
            minRows={1}
            maxRows={3}
            {...formikProps}
          />
          <Button
            type="button"
            className={classNames(
              styles.buttonSearch,
              'btn btn-sm p-4 d-flex justify-content-center align-items-center ml-4'
            )}
            onClick={() => applyFilter(values, true)}
            disabled={context.loading || !values.query}
          >
            <img src={toAbsoluteUrl('/media/svg/AI_white.svg')} alt="i" height={32}/>
          </Button>
        </div>
      )}
    </Formik>
  );
}